import React from "react";
import { Typography } from "@bca/ui-library";

import { getTimeUntilSaleEnds } from "../helpers/getTimeUntilSaleEnds";
import CountdownTimer from "./CountdownTimer";

interface SaleDateTimeBNBNProps {
  startDate: string;
  endDate: string;
}

const isToday = (date: Date) => {
  const today = new Date();

  return (
    date.getDate() == today.getDate() &&
    date.getMonth() == today.getMonth() &&
    date.getFullYear() == today.getFullYear()
  );
};

const isTomorrow = (date: Date) => {
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);

  return (
    date.getDate() == tomorrow.getDate() &&
    date.getMonth() == tomorrow.getMonth() &&
    date.getFullYear() == tomorrow.getFullYear()
  );
};

export const getSaleDate = (saleDate: string) => {
  const weekday = new Date(saleDate).toLocaleString("en-GB", {
    weekday: "long",
  });
  const date = new Date(saleDate).toLocaleString("en-GB", {
    day: "2-digit",
  });
  const month = new Date(saleDate).toLocaleString("en-GB", {
    month: "long",
  });
  if (isToday(new Date(saleDate))) {
    return "Today";
  } else if (isTomorrow(new Date(saleDate))) {
    return "Tomorrow";
  }
  return `${weekday} ${date} ${month}`;
};

export const getSaleTime = (saleDate: string) => {
  return `at ${new Date(saleDate).toLocaleTimeString("en-GB", {
    hour12: false,
    hour: "2-digit",
    minute: "2-digit",
  })} `;
};

const SaleDateTimeBNBN: React.FunctionComponent<SaleDateTimeBNBNProps> = ({
  startDate,
  endDate,
}) => {
  const today = new Date();
  const saleTimeUTC = new Date(startDate).toLocaleTimeString("en-GB", {
    timeZone: "UTC",
    hour12: false,
  });
  const showCountdownTimer = getTimeUntilSaleEnds(endDate) <= 60;

  const saleHasStarted = today > new Date(startDate);
  const saleStartsAtMidnight = saleTimeUTC === "00:00:00";

  return (
    <>
      {showCountdownTimer ? (
        <CountdownTimer saleEndDate={endDate}></CountdownTimer>
      ) : (
        <Typography variant="body" color="grey-blue" marginY="2px">
          {saleHasStarted
            ? `Ends ${getSaleDate(endDate)} ${
                saleStartsAtMidnight ? "" : getSaleTime(endDate)
              }`
            : `Starts ${getSaleDate(startDate)} ${
                saleStartsAtMidnight ? "" : getSaleTime(startDate)
              }`}
        </Typography>
      )}
    </>
  );
};

export default SaleDateTimeBNBN;
